/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetBlueprintMetadataMetadataQueryResponse, GetBlueprintMetadataMetadataPathParams, GetBlueprintMetadataMetadataQueryParams, GetBlueprintMetadataMetadata400, GetBlueprintMetadataMetadata404 } from "../models/GetBlueprintMetadataMetadata";

export function getGetBlueprintMetadataMetadataUrl(reportType: GetBlueprintMetadataMetadataPathParams["reportType"]) {
  const res = { method: 'GET', url: `/report-blueprints/${reportType}` as const }
  return res
}

/**
 * @description Retrieves blueprint metadata (sections, categories, columns) for the specified report type. If blueprintVersion is provided, uses that version; otherwise uses the latest. The response excludes internal implementation details like extraction methods.
 * @summary Get blueprint metadata
 * {@link /report-blueprints/:reportType}
 */
export async function getBlueprintMetadataMetadata(reportType: GetBlueprintMetadataMetadataPathParams["reportType"], params?: GetBlueprintMetadataMetadataQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetBlueprintMetadataMetadataQueryResponse, ResponseErrorConfig<GetBlueprintMetadataMetadata400 | GetBlueprintMetadataMetadata404>, unknown>({ method : "GET", url : getGetBlueprintMetadataMetadataUrl(reportType).url.toString(), params, ... requestConfig })
  return res.data
}